import React from "react";
import "./style.scss";
import { FormattedMessage } from "react-intl";

const KPIItem = ({ text, label }) => {
  return (
    <div className="kpi-item-container">
      <div className="label">
        {label ? <FormattedMessage id={label} /> : ""}
      </div>
      <div className="text">{text || "---"}</div>
    </div>
  );
};

export default KPIItem;
